import { Button, Form, Input, Spin } from 'antd';
import axios from 'axios';
import qs from 'qs';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BaseUrlAuth, BaseUrlGeneral } from '../../../../utils';
import Logo from '../../../general/logo';
import { InputData, ProfileData } from '../../../utils/interfaces';
import './index.scss';

const formRules: object[] = [
  {
    type: 'email',
    message: 'The input is not valid E-mail!',
  },
  {
    required: true,
    message: 'Please input your E-mail!',
  },
];
const passwordRules: object[] = [
  {
    required: true,
    message: 'Please input your password!',
  },
];

const tailFormItemLayout = {};

const formItemLayout = {};

const StyledInput = styled(Input)`
  color: #d5d5d5;
  ::-webkit-calendar-picker-indicator {
    content: url(/calendar_today.png);
    background: #59606a;
  }
`;

const SignUp: React.FC = ({}): JSX.Element => {
  const history = useNavigate();
  var ref = useRef<any>();
  const [form] = Form.useForm();

  const [inputData, setInputData] = useState<InputData>();
  const [authData, setAuthData] = useState<any>({
    email: '',
    password: '',
    is_active: 1,
  });
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const navigation = useNavigate();

  function prepareProfileData(data: any) {
    var preparedData: any = {};
    preparedData['name'] = data['firstname'] + ' ' + data['lastname'];
    preparedData['email'] = data['email'];
    preparedData['date_of_birth'] = data['date_of_birth'];
    preparedData['gender'] =
      data['gender'] === 'male' ? 1 : data['gender'] === 'female' ? 2 : 3;
    preparedData['mobile'] = data['mobile'];
    preparedData['designation_id'] = 1;
    return preparedData;
  }

  const handleProfileDataChange = (e: any) => {
    setInputData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleAuthDataChange = (e: any) => {
    setAuthData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSubmit = (e: any) => {
    setIsSubmitted(true);
    console.log(authData);
    const preparedData: ProfileData = prepareProfileData(inputData);
    setErrorMessage('');
    axios
      .post(BaseUrlAuth + `/api/v1/auth/register`, authData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        axios
          .post(
            BaseUrlAuth + `/api/v1/auth/jwt/login`,
            qs.stringify({
              username: authData['email'],
              password: authData['password'],
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            }
          )
          .then((res) => {
            axios
              .post(
                BaseUrlGeneral + `/api/v1/profile/user-profiles/`,
                preparedData,
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + res.data.access_token,
                  },
                }
              )
              .then((res) => {
                history('/signin', {
                  state: {
                    message:
                      'Account is created successfully! Please login to continue',
                  },
                });
              })
              .catch((error) => {
                setErrorMessage(error.response.data.detail[0].msg);
                console.log(error);
              })
              .finally(() => {
                setIsSubmitted(false);
              });
          })
          .catch((error) => {
            setErrorMessage(error.response.data.detail);
            console.log(error);
          })
          .finally(() => {
            setIsSubmitted(false);
          });
      })
      .catch((error) => {
        // console.log(error.response.data.detail.reason)
        // if (error.response.status === 400) {
        //   if (error.response.data.detail === 'REGISTER_USER_ALREADY_EXISTS') {
        //     setErrorMessage(
        //       'A user is already registered with this e-mail address.'
        //     );
        //   } else {
        //     setErrorMessage(error.response.data.detail.reason);
        //   }
        // }
        // if (error.response.status === 422) {
        //   setErrorMessage(error.response.data.detail[0].msg);
        // }
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  return (
    <div className="signup-page">
      <div style={{ marginTop: '25vh' }}>
        <Logo {...{ size: 'large' }} />
      </div>

      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={handleSubmit}
        scrollToFirstError
      >
        <div className="container-xxl signup-container">
          <div className="row custom-row">
            <div className="col">
              <Form.Item
                name="FirstName"
                label=""
                className="input-field FirstName"
                rules={[
                  {
                    required: true,
                    message: 'Please input your First Name!',
                    whitespace: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value.length < 24) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Name is too long'));
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="First Name"
                  name="firstname"
                  onChange={handleProfileDataChange}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="LastName"
                label=""
                className="input-field LastName"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Last Name!',
                    whitespace: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value.length < 24) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Name is too long'));
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Last Name"
                  name="lastname"
                  onChange={handleProfileDataChange}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row custom-row">
            <div className="col">
              <Form.Item
                className="input-field email"
                name="email"
                label=""
                rules={formRules}
              >
                <Input
                  placeholder="Email"
                  name="email"
                  onChange={(e) => {
                    handleProfileDataChange(e);
                    handleAuthDataChange(e);
                  }}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="phone"
                label=""
                className="input-field phone"
                rules={[
                  {
                    required: true,
                    message: 'Please input your phone number!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value.length < 20) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Number is too long'));
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Phone Number"
                  name="mobile"
                  onChange={handleProfileDataChange}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row custom-row">
            <div className="col">
              <Form.Item
                name="date-of-birth"
                label=""
                className="input-field"
                rules={[
                  {
                    required: true,
                    message: 'Please input your date of birth!',
                  },
                  ({ getFieldValue }: any) => ({
                    validator(_, value) {
                      var input = new Date(value);
                      var today = new Date();
                      var Difference_In_Time =
                        today.getTime() - input.getTime();
                      var Difference_In_Days =
                        Difference_In_Time / (1000 * 3600 * 24);
                      console.log(Difference_In_Days);

                      if (!value || Difference_In_Days > 5840) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          'Your age should be at least 16 years or 5840 days!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <StyledInput
                  type="text"
                  name="date_of_birth"
                  onFocus={(e) => (e.target.type = 'date')}
                  onBlur={(e) => (e.target.type = 'text')}
                  placeholder={'Date of Birth'}
                  onChange={handleProfileDataChange}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="gender"
                label=""
                className="input-field"
                rules={[{ required: true, message: 'Please select gender!' }]}
              >
                <select
                  className="gender"
                  // placeHolder="Select your gender"
                  name="gender"
                  onChange={handleProfileDataChange}
                >
                  <option value="" disabled selected>
                    Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </Form.Item>
            </div>
          </div>
          <div className="row custom-row">
            <div className="col">
              <Form.Item
                name="password"
                className="input-field"
                label=""
                rules={passwordRules}
              >
                <Input.Password
                  placeholder="Password"
                  className="input-password"
                  name="password"
                  onChange={handleAuthDataChange}
                />
              </Form.Item>
            </div>
            <div className="col">
              <Form.Item
                name="confirm"
                label=""
                className="input-field"
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          'The two passwords that you entered do not match!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="input-password"
                  placeholder="Confirm Password"
                />
              </Form.Item>
            </div>
          </div>
          <p style={{ color: 'red' }}>{errorMessage}</p>
          {isSubmitted ? (
            <Spin size="large" style={{ margin: '10px' }} />
          ) : (
            <></>
          )}
          <div className="row custom-row">
            <div className="col">
              <Form.Item
                className="input-field Sign-Up-Button"
                {...tailFormItemLayout}
                style={{ paddingTop: '10px' }}
              >
                <Button type="primary" htmlType="submit">
                  Sign Up
                </Button>
              </Form.Item>
            </div>
          </div>
          <p
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              color: '#D5D5D5',
              gridColumn: '1/span 2',
            }}
          >
            Already have an account?{' '}
            <span
              onClick={() => navigation('/signin')}
              style={{
                color: '#8CC63E',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              {' '}
              Sign In
            </span>
          </p>
        </div>
      </Form>
    </div>
  );
};

export default SignUp;
